<dx-popup
  [showTitle]="true"
  [title]="dialogTitle()"
  [visible]="displayDialog()"
  (onHidden)="closeDialog()"
  [width]="600"
  [height]="'auto'"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  (onHidden)="closeDialog()">

  <form novalidate>

    <div class="dialog-line">
      <div class="label" title="Site">Site <span class="danger-color">*</span></div>
      <div class="value">
        <dx-select-box
          [dataSource]="findAllLocalSites()"
          displayExpr="libelle"
          valueExpr="id"
          [value]="formData().site?.id"
          placeholder="Sélectionner le site..."
          (onSelectionChanged)="onChangeSite($event)">
        </dx-select-box>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Libellé">Libellé <span class="danger-color">*</span></div>
      <div class="value">
        <dx-text-box
          class="inputfield"
          placeholder="Libellé"
          [value]="formData().libelle"
          (onValueChanged)="onChangeLibelle($event)">
        </dx-text-box>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Code">Code <span class="danger-color">*</span></div>
      <div class="value">
        <dx-text-box
          class="inputfield"
          placeholder="Code"
          [value]="formData().code"
          (onValueChanged)="onChangeCode($event)">
        </dx-text-box>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Actif">Actif</div>
      <div class="value">
        <dx-check-box
          [value]="formData().actif"
          (onValueChanged)="onChangeActif($event)">
        </dx-check-box>
      </div>
    </div>

    <div class="dialog-line">
      <div class="custom-button-container-right">
        <yo-button
          tooltip="Enregistrer le secteur d'activité"
          iconClass="fas fa-save"
          [theme]="ButtonThemeEnum.SAVE"
          [disabled]="!isFormValid()"
          (onClick)="save()">
        </yo-button>
        <yo-button
          tooltip="Fermer"
          (onClick)="closeDialog()"
          iconClass="fas fa-times"
          [theme]="ButtonThemeEnum.CANCEL">
        </yo-button>
      </div>
    </div>

  </form>
</dx-popup>
